import { GetOffchainData } from './GetOffchainData';
import { GetImage } from './GetImage';
import { Reroute } from './Reroute';
import { GetOffchainDataV2 } from './GetOffchainDataV2';
import { Reflow } from './Reflow';
import { TradingGraph } from './TradingGraph';
var OffchainData = {
    getters: {
        GetOffchainData: GetOffchainData,
        GetImage: GetImage,
        Reroute: Reroute,
        GetOffchainDataV2: GetOffchainDataV2,
        Reflow: Reflow,
        TradingGraph: TradingGraph,
    },
};
export { OffchainData };
